import React, { useState } from "react";
import { Tabs } from "@mantine/core";
import { useAuthUser } from "react-auth-kit";
import { useServerApi } from "../hooks/userServerApi";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import OrderStatics from "../components/orderStatics";
import OrderStatsTable from "../components/orderStatsTable";
import ForcastPayrollBarChart from "../components/forcastPayrollBarChart";
import { useTranslation } from "react-i18next";
import { DashboardGiOutstandingConsultantTab } from "../components/dashboardGiOverdueTab";

function DashboardConsultant({ role, numQuarters = 8 }) {
  const auth = useAuthUser();
  const [api] = useServerApi();
  const { t } = useTranslation();

  const [period, setPeriod] = useState(null);
  const [dateType, setDateType] = useState("signedDate");
  const [orderStats, setOrderStats] = useState();

  const fetchOrderStats = async () => {
    const userId = auth()?.id;
    if (!userId) return;
    if (!period || !period.startDate || !period.endDate) return;

    const data = await api.Order.getStats(period, userId, dateType);
    if (!data) return;
    setOrderStats(data.orderSummary ?? []);
  };

  useDeepCompareEffect(() => {
    fetchOrderStats();
  }, [auth()?.id, period, dateType]);

  const orderRemark =
    "Order sign date is used as the date range filter. Split cases count as 0.5. Only NEW business data will be shown.";

  return (
    <>
      <OrderStatsTable
        data={orderStats}
        mt="50px"
        highlightOnHover
        withTableBorder
        showIndividualConsultant={true}
        remark={orderRemark}
        onPeriodRefresh={() => fetchOrderStats()}
        onPeriodChange={(p) => setPeriod(p)}
        onDateTypeChange={(t) => setDateType(t)}
        numPeriods={numQuarters}
      />

      <Tabs defaultValue="order" mt="100px">
        <Tabs.List>
          <Tabs.Tab value="order">{t("Order")}</Tabs.Tab>
          <Tabs.Tab value="giOutstanding">
            {t("dashboard.giOutstanding", "GI Outstanding")}
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="order">
          <OrderStatics
            userId={auth()?.id}
            hideTable
            period={period}
            dateType={dateType}
            onPeriodChange={setPeriod}
            onDateTypeChange={setDateType}
            numPeriods={numQuarters}
          />
          <ForcastPayrollBarChart />
        </Tabs.Panel>

        <Tabs.Panel value="giOutstanding">
          <DashboardGiOutstandingConsultantTab scopeToSelf />
        </Tabs.Panel>
      </Tabs>
    </>
  );
}

export default DashboardConsultant;
